export default __webpack_public_path__ + "static/media/payment_success.fb3db946.svg";